import { buildScaleValueTrigger, parseScaleValueTrigger } from './scale.js';
import { singlePickReachability } from './single-pick-reachability.js';
/** @param values the EFFECTIVE positions, roles already resolved through any matched branch. */
export function scaleReachability(d, values) {
    const r = singlePickReachability(d, values, v => buildScaleValueTrigger(v.value), trigger => parseScaleValueTrigger(trigger) !== null);
    return { states: r.states, correctValues: r.correctItems, uncoveredWrong: r.uncoveredWrong };
}
//# sourceMappingURL=scale-reachability.js.map